import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { booksFetch, searchBooks } from '../../../actions/booksActions';

// components
import IndexRow from './_IndexRow';
import { Panel, PanelBody, PanelHeader } from '../../shared/_panel';
import Spinner from '../../shared/_Spinner';
import PremiumFeature from '../../shared/PremiumFeature';
import Advertisement from '../../shared/_advertisement';
import { DebounceInput } from 'react-debounce-input';


class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      activeIndex: 1,
    };
  }

  static propTypes = {
    books:          PropTypes.instanceOf(Immutable.Map),
    fetchBooks:     PropTypes.func.isRequired,
    fetchUserBooks: PropTypes.func.isRequired
  };

  _handleClick = (index) => {
    this.setState({ activeIndex: index });
  }

  _checkActive = (index, className) => this.state.activeIndex === index ? className : "";

  componentDidMount() {
    this._initBooks();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeIndex !== this.state.activeIndex) {
      this._initBooks();
    }
  }

  _handleOfficeSearch = (event) => {
    if (this.state.activeIndex !== 1) {
      this.setState({ activeIndex: 1 })
    }

    const searchBooks = this.props.searchBooks;
    const officeQuery = event.target.value;

    if (officeQuery.length === 0) {
      this._initBooks();
    } else if (officeQuery.length >= 2) {
      searchBooks(officeQuery);
    }
  };

  render() {
    const { books } = this.props;
    const loading = books.get('loading') && !books.get('data');

    return (
      <React.Fragment>
        <div className='body__content body__content--center rep-books-index'>
          <Panel>
            <Advertisement />
            <PanelHeader className={ 'panel__header--open-books reps__search__header' }>
              <div>
                <div className={ 'follow-message follow-border' }>
                  <i aria-hidden='true' className='fa fa-star follow-message__icon' />
                  <div className={ 'follow-message__content' }>
                    <div className={ 'follow-message__text' }>
                              Please select accounts you want to Follow
                    </div>
                  </div>
                </div>
                <div className='rep-books__filter'>
                  <div className='tabs'>
                    <button
                      className={`tab ${this._checkActive(1, 'active')}`}
                      onClick={() => this._handleClick(1)}
                    >
                      All
                    </button>
                    <button
                      className={`tab ${this._checkActive(2, 'active')}`}
                      onClick={() => this._handleClick(2)}
                    >
                      Following
                    </button>
                  </div>
                  
                  <div className='books-reps__search-bar'>
                    <DebounceInput className='books-reps__search-box'
                      debounceTimeout={ 500 }
                      onChange={ this._handleOfficeSearch }
                      placeholder={ 'Search any Office by name' }
                    />
                    <i aria-hidden='true' className='fa fa-search books-reps__search-icon' />
                  </div>
                </div>
              </div>
            </PanelHeader>
            <PanelBody className='rep-books-index__list__body'>
              <Spinner className='rep-books-index__list' enabled={ loading }>
                <div  className='rep-books-index__list__header'>
                  <div className='rep-books-index__list__header__label rep-books-index__list__header__label--left'>
                  Office
                  </div>
                  <div className='rep-books-index__list__header__label rep-books-index__list__header__label--right'>
                  Open Apts.
                  </div>
                </div>
                { this._renderBooks() }
              </Spinner>
            </PanelBody>
          </Panel>
        </div>
      </React.Fragment>
    );
  }

  // private

  _initBooks() {
    const { fetchUserBooks, fetchBooks } = this.props;

    if (this.state.activeIndex === 1) {
      fetchBooks();
    } else {
      fetchUserBooks();
    }
  }

  _renderBooks() {
    const { books } = this.props;
    const items     = books.get('data') || Immutable.Map();
    const result    = books.get('result') || Immutable.List();
    const elements  = [];

    result.forEach((id) => {
      const book = items.get(id) || Immutable.Map();

      elements.push(
        <IndexRow book={ book } key={ id } />
      );
    });
    return elements;
  }
}

const mapStateToProps = (state) => {
  return {
    books: state.get('books', Immutable.Map())
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBooks: () => {
      dispatch(booksFetch());
    },
    fetchUserBooks: () => {
      dispatch(booksFetch('following'));
    },
    searchBooks: (query) => {
      dispatch(searchBooks(query))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/reps/books/Index.jsx